var _mask, _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_933_6556",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 19,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 19,
    rx: 1,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_933_6556)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 5,
    r: 4.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12C9.75 11.8619 9.86193 11.75 10 11.75H18C18.1381 11.75 18.25 11.8619 18.25 12V18C18.25 18.1381 18.1381 18.25 18 18.25H10C9.86193 18.25 9.75 18.1381 9.75 18V12Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidential);
export default __webpack_public_path__ + "static/media/Residential.5e367c6c78a023ebe74cc0ae96d6b95d.svg";
export { ForwardRef as ReactComponent };